import { request } from './client';
import type { ScoringModel } from './types';

/**
 * Sistem Parametreleri — the settings that decide how the product behaves rather than what
 * is in it.
 *
 * One screen, sections inside it, one endpoint per section. A single blob holding every
 * parameter would mean a screen that cannot be extended without every other section's
 * state travelling with the one being saved.
 */

const base = '/api/v1/parameters/system';

export interface ScoringSettings {
  model: ScoringModel;
  pointsTarget: number;

  /** Whether the auditor sees what each question is worth while filling it in. */
  showQuestionPoints: boolean;

  /** Whether the auditor sees the running and category figures while they work. */
  showRunningScore: boolean;
}

export const systemParameters = {
  scoring: () => request<ScoringSettings>(`${base}/scoring`),

  saveScoring: (settings: ScoringSettings) =>
    request<ScoringSettings>(`${base}/scoring`, {
      method: 'PUT',
      body: JSON.stringify(settings),
    }),
};
